import React from 'react'
// import './App.css'

const App = () => {
  return (
    <div>
      <h2>Page in construction</h2>
    </div>
  )
}

export default App
